// extracted by mini-css-extract-plugin
export default {"banner":"style_banner__E-toJ","img":"style_img__YuvqS","btns":"style_btns__syUu+","header":"style_header__BavyE"};